"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useAlreadyInsuredCarCheck_1 = require("./useAlreadyInsuredCarCheck");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return useAlreadyInsuredCarCheck_1.default; } });
//# sourceMappingURL=index.js.map